import React, { useState, useEffect } from 'react';
import { Container, Row, Card, Col, Button, Form } from 'react-bootstrap';
import { useHistory, Link } from 'react-router-dom';
import { ArrowBackIos, WidgetsOutlined, Add, FileCopy } from '@material-ui/icons';
import BootstrapTable from 'react-bootstrap-table-next';
import masterAgentService from '../../services/master-agent-request';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import { parseDateBR } from 'helpers/date';
import { useCompany } from 'models';

import './style.scss'

export default function(){
  const { company: currentCompany } = useCompany()

  const defaultFilters = { per_page: 10, page: 1 };

  const history = useHistory();
  const [filters, setFilters] = useState(defaultFilters);
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({ })
  const [isLoading, setIsLoading] = useState(false)

  const configCol = {
    headerStyle: {
      textAlign: 'center'
    },
    style: {
      textAlign: 'center'
    }
  }

  const columns = [
    {
      dataField: 'id',
      text: 'Código',
      ...configCol
    },
    {
      dataField: 'company',
      text: 'Revenda',
      ...configCol
    },
    {
      dataField: 'provider',
      text: 'Fornecedor/Tipo ',
      ...configCol
    },
    {
      dataField: 'client_name',
      text: 'Cliente',
      ...configCol
    },
    {
      dataField: 'pdf_file_path',
      text: 'PDF',
      ...configCol
    },
    {
      dataField: 'created_at',
      text: 'Data Criação',
      ...configCol
    }
  ];

  useEffect(() => {
    const get = async () => {
      let _filters = {
        ...filters
      }

      if (currentCompany) {
        _filters['company_id'] = currentCompany.id;
      }

      const response = await masterAgentService.getOpportunities({ params: _filters })
      const { data, pagination } = response.data
      setData(data.map(({ id, provider, company, url_file_path, form_data, created_at }) => ({
        id,
        company: company.alias ?? company.name,
        created_at: parseDateBR(created_at),
        provider: provider ? provider.name : 'TELEFONIA EM NUVEM',
        pdf_file_path: renderFilePath(url_file_path),
        client_name: JSON.parse(form_data).client_company_name ?? JSON.parse(form_data).client_name
      })))
      setPagination(pagination)
    }

    get()
  }, [filters])



  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  };

  const renderFilePath = url => {
    return (
      <a href={url} target="_blank">Visulizar Arquivo <FileCopy /></a>
    )
  }

  // const renderActionsBtn = id => {
  //   return (
  //     <Button
  //       disabled={isLoading}
  //       variant="info"
  //       size="sm"
  //       onClick={() => {
  //         setIsLoading(true)
  //         masterAgentService.resendEmailOpportunity({ id })
  //           .then(() => {
  //             swal.success("O reenvio foi feito com sucesso!");
  //           })
  //           .finally(() => setIsLoading(false));
  //       }}
  //     >
  //       {isLoading ? (<>
  //         Enviando <Spinner Spinner animation="border" size="sm" />
  //       </>) : 'Reenviar'}
  //     </Button>
  //   )
  // }

  return (
    <Container fluid>
      <Row className="mt-2">
        <Link to="/master-agent/my-quotes" className="link-back">
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Link>
      </Row>
      <Row className="mt-1">
        <WidgetsOutlined className="icon-title col-auto p-0" />
        <h5 className="title-dashboard col-10 p-0">Pré Vendas - Oportunidades</h5>
      </Row>
      <Row>
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 mb-5 col-12">
          <Row>
            {currentCompany ? (
              <Col md="12" className="mb-3">
                <Button
                  className="btn-add mr-3"
                  onClick={() => history.push('/master-agent/my-quotes/opportunities/add')}
                >
                  <Add /> Registrar Oportunidade
                </Button>
              </Col>
            ) : (<></>)}
            <Col md="12" className="mb-3">
              <Form.Row>
                <Col md="2">
                  <Form.Group>
                    <Form.Label>Por Pagina</Form.Label>
                    <Form.Control
                      as="select"
                      value={filters.per_page}
                      onChange={e =>
                        handleFilterChange({ per_page: e.target.value })
                      }
                    >
                      <option>5</option>
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>50</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Form.Row>
            </Col>
            <Col md="12">
              <BootstrapTable
                id="table"
                className="font-10"
                keyField="id"
                data={data}
                columns={columns}
                striped
                hover
                condensed
                bordered
              />
            </Col>
            <Col xs="12" md="6">
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: pagination.from || '0' }} to{' '}
                {{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
                records
              </Trans>
            </Col>
            <Col xs="12" md="6" className="d-flex justify-content-end">
              <Pagination
                activePage={pagination.current_page}
                itemsCountPerPage={pagination.per_page}
                totalItemsCount={pagination.total}
                pageRangeDisplayed={5}
                onChange={page => handleFilterChange({ page })}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Card.Body>
      </Row>
    </Container>
  )
}